
import Helper from "./Helper";

class BusinessModel {
  constructor(config = {}) {
    const { idName, className } = config;

    this.idName = idName;
    this.className = className;

    document.querySelectorAll('g[id^="toggle-"]').forEach(button => {
      button.addEventListener('click', (event) => {

        const toggleNumber = button.id.split('-')[1];
        if (!toggleNumber) {
          console.warn('Keine Nummer in der ID gefunden.');
          return;
        }

        const popup = document.querySelector(`.bm-popup.bm-popup--${toggleNumber}`);
        if (!popup) {
          console.warn(`Kein Popup mit der Klasse "bm-popup--${toggleNumber}" gefunden.`);
          return;
        }

        if(popup.classList.contains('bm-popup--active')) {
          this.closeAllPopups();
          return;
        }

        // if(popup.classList.contains('bm-popup--video')) {
        //   document.querySelector('.ns-business-model__bm-popups').classList.add('ns-business-model__bm-popups--active');
        //   popup.querySelector('iframe').src = popup.querySelector('iframe').src + '?autoplay=1';
        // }

        if (popup.classList.contains('bm-popup--video')) {
          const popupsContainer = document.querySelector('.ns-business-model__bm-popups');
          if (popupsContainer) {
            popupsContainer.classList.add('ns-business-model__bm-popups--active');
          }
          popup.querySelector('iframe').src = popup.querySelector('iframe').src + '?autoplay=1';
        }

        const buttonRect = button.getBoundingClientRect();

        popup.style.display = 'block';
        popup.style.position = 'absolute';

        const popupWidth = popup.offsetWidth;
        const popupHeight = popup.offsetHeight;

        const scrollY = window.scrollY || document.documentElement.scrollTop;
        const minus = (document.body.offsetWidth - document.querySelector('.ns-business-model__bm-popups').offsetWidth) / 2;

        popup.style.top = `${scrollY + buttonRect.top + buttonRect.height - (popupHeight / 2) - 75.5 - this.getElementOffsetTop(document.querySelector('.ns-business-model'))}px`;
        popup.style.left = `${buttonRect.left + buttonRect.width - minus + 40 - popupWidth - 55}px`;

        document.querySelectorAll('.bm-popup').forEach(p => {
          if (p !== popup) {
            p.classList.remove('bm-popup--active');
            setTimeout(() => {
              p.style.display = 'none';
            }, 250);
          }
        });

        popup.classList.add('bm-popup--active');
      });
    });

    document.addEventListener('click', (event) => {
      if (!event.target.closest('g[id^="toggle-"]') && !event.target.closest('.bm-popup')) {
        this.closeAllPopups();
      }
    });

    document.querySelectorAll('.bm-popup__button').forEach(button => {
      button.addEventListener('click', (event) => {
        this.closeAllPopups();
        if(button.closest('.bm-popup--video').querySelector('iframe')) {
          const iframe = button.closest('.bm-popup--video').querySelector('iframe');
          iframe.src = iframe.src.replace('?autoplay=1', '');
        }
      });
    });

  }

  // closeAllPopups() {
  //   document.querySelector('.ns-business-model__bm-popups').classList.remove('ns-business-model__bm-popups--active');
  //   document.querySelectorAll('.bm-popup').forEach(popup => {
  //     popup.classList.remove('bm-popup--active');
  //     setTimeout(() => {
  //       popup.style.display = 'none';
  //     }, 250);
  //   });
  // }

  closeAllPopups() {
    const popupsContainer = document.querySelector('.ns-business-model__bm-popups');
    if (popupsContainer) {
      popupsContainer.classList.remove('ns-business-model__bm-popups--active');
    }
    document.querySelectorAll('.bm-popup').forEach(popup => {
      popup.classList.remove('bm-popup--active');
      setTimeout(() => {
        popup.style.display = 'none';
      }, 250);
    });
  }



  getElementOffsetTop(element) {
    let offsetTop = 0;

    while (element) {
      offsetTop += element.offsetTop;
      element = element.offsetParent;
    }

    return offsetTop;
  }
}

export default BusinessModel;
